import { PICWebSocketClient, PIC, fetchApiData, exportFetchURL, fetchRestApi } from "../../templates/Internals";
export class PICNotificationManager {
    constructor() {
        this.notificationChannels = new Map();
        this.consumers = [];
    }
    addConsumer(iConsumer) {
        this.consumers.push(iConsumer);
    }
    removeConsumer(iConsumer) {
        this.consumers.splice(this.consumers.indexOf(iConsumer), 1);
    }
    addAPI(url, iOptions) {
        if (url.length === 0 || this.notificationChannels.has(url))
            return;
        let nh = new NotificationHolder({ apiURL: url, apiRefreshTimer: iOptions.apiRefreshTimer, callback: this.notifyConsumers.bind(this) });
        this.notificationChannels.set(url, nh);
    }
    addChannel(iChannelId) {
        let tmpChannel = this.notificationChannels.get(iChannelId);
        if (tmpChannel) {
            if (tmpChannel.isActive) {
                // don't subscribe again if active connection exists. 
                return;
            }
        }
        let nh = new NotificationHolder({ channelId: iChannelId, callback: this.notifyConsumers.bind(this) });
        this.notificationChannels.set(iChannelId, nh);
        // get initial notifications 
        let tmp = {
            formatOutput: "text",
            postBody: {
                mode: 'getNotifications',
                data: {
                    channel: iChannelId,
                }
            }
        };
        fetchApiData('notifications/catchuphandler', tmp).then((iData) => {
            nh.handleMessage({ data: iData });
        });
    }
    notifyConsumers(iData) {
        this.consumers.forEach(consumer => {
            consumer.handleNotification(iData);
        });
    }
    get unseenNotificationCount() {
        let res = 0;
        this.notificationChannels.forEach(val => { res += val.unseenNotifications.length; });
        return res;
    }
    get notificationCount() {
        let res = 0;
        this.notificationChannels.forEach(val => { res += val.notifications.length; });
        return res;
    }
    get notificationPriorityCount() {
        let res = [0, 0, 0, 0];
        this.notificationChannels.forEach(val => {
            val.notifications.forEach(not => {
                switch (not.priority) {
                    case "high":
                        res[0]++;
                        break;
                    case 'medium':
                        res[1]++;
                        break;
                    case 'low':
                        res[2]++;
                        break;
                    case 'info':
                        res[3]++;
                        break;
                    default:
                        break;
                }
            });
        });
        return res;
    }
    get allNotifications() {
        let res = [];
        this.notificationChannels.forEach(val => { res = res.concat(val.notifications); });
        return res;
    }
    get channels() {
        let res = [];
        this.notificationChannels.forEach((val, key) => res.push(key));
        return res;
    }
    removeNotification(iChannelId, iNotification) {
        var _a, _b;
        let res = (_b = (_a = this.notificationChannels.get(iChannelId)) === null || _a === void 0 ? void 0 : _a.removeNotification(iNotification)) !== null && _b !== void 0 ? _b : false;
        if (res) {
            let tmp = {
                postBody: {
                    mode: 'remove',
                    data: {
                        channel: iChannelId,
                        id: (typeof iNotification == 'string') ? iNotification : iNotification.id
                    }
                }
            };
            fetchApiData('notifications/eventhandler', tmp).then((data) => {
            });
        }
        return res;
    }
    updateNotification(iChannelId, iNotification) {
        var _a;
        let found = (_a = this.notificationChannels.get(iChannelId)) === null || _a === void 0 ? void 0 : _a.updateNotification(iNotification);
        if (found) {
            let tmp = {
                postBody: {
                    mode: 'update',
                    data: {
                        channel: iChannelId,
                        notification: JSON.stringify(iNotification),
                    }
                }
            };
            fetchApiData('notifications/eventhandler', tmp).then((data) => {
            });
        }
    }
    getNotifications(iChannelId) {
        var _a;
        if (this.notificationChannels.get(iChannelId))
            return (_a = this.notificationChannels.get(iChannelId)) === null || _a === void 0 ? void 0 : _a.notifications;
        return [];
    }
    getNotification(iChannelId, iNotificationId) {
        var _a;
        return (_a = this.notificationChannels.get(iChannelId)) === null || _a === void 0 ? void 0 : _a.getNotification(iNotificationId);
    }
    getFilteredNotifications(iOpt) {
        var _a, _b;
        let res = [];
        if (!iOpt)
            return this.allNotifications;
        if (iOpt === null || iOpt === void 0 ? void 0 : iOpt.channelId) {
            res = (_b = (_a = this.notificationChannels.get(iOpt.channelId)) === null || _a === void 0 ? void 0 : _a.notifications) !== null && _b !== void 0 ? _b : [];
        }
        else {
            res = this.allNotifications;
        }
        //this will never get out of hand and become unreadable!
        if (iOpt.priority || 'seen' in iOpt || 'done' in iOpt) {
            if (iOpt.priority && 'seen' in iOpt && 'done' in iOpt) {
                res = res.filter(val => { return iOpt.priority.includes(val.priority) && val.seen == iOpt.seen && val.done == iOpt.done; });
            }
            else if ('seen' in iOpt && 'done' in iOpt) {
                res = res.filter(val => { return val.seen == iOpt.seen && val.done == iOpt.done; });
            }
            else if (iOpt.priority && 'done' in iOpt) {
                res = res.filter(val => { return iOpt.priority.includes(val.priority) && val.done == iOpt.done; });
            }
            else if (iOpt.priority && 'seen' in iOpt) {
                res = res.filter(val => { return iOpt.priority.includes(val.priority) && val.seen == iOpt.seen; });
            }
            else if (iOpt.priority) {
                res = res.filter(val => { return iOpt.priority.includes(val.priority); });
            }
            else if ('seen' in iOpt) {
                res = res.filter(val => { return val.seen == iOpt.seen; });
            }
            else {
                res = res.filter(val => { return val.done == iOpt.done; });
            }
        }
        return res;
    }
}
class NotificationHolder {
    constructor(iOptions) {
        this.notifyAPIRefreshTimer = 60000; //ms
        if (iOptions.apiURL) {
            this.notifyAPIUrl = iOptions.apiURL;
            this.notifyAPIRefreshTimer = iOptions.apiRefreshTimer > 5000 ? iOptions.apiRefreshTimer : 60000;
            this.notifyParent_ = iOptions.callback;
            this.notifications_ = [];
            setTimeout(() => this.fetchNotifications(this.notifyAPIUrl), 1000);
            this.intervalId = setInterval(() => {
                var _a, _b, _c;
                if (((_c = (_b = (_a = PIC.getInstance) === null || _a === void 0 ? void 0 : _a.getNotificationManager()) === null || _b === void 0 ? void 0 : _b.consumers) === null || _c === void 0 ? void 0 : _c.length) === 0 || document.querySelector('header pic-badge') == null) {
                    clearInterval(this.intervalId);
                    return;
                }
                this.fetchNotifications(this.notifyAPIUrl);
            }, this.notifyAPIRefreshTimer);
        }
        else {
            this.socketChannel_ = new PICWebSocketClient({ host: exportFetchURL({ path: 'wss' }), port: '', channelId: iOptions.channelId, sessionCode: PIC.sessionCode, systemId: PIC.systemId, managedByPic: true });
            this.socketChannel_.addSocketEventListener('message', this.handleMessage.bind(this));
            this.notifications_ = [];
            this.notifyParent_ = iOptions.callback;
        }
    }
    get notifications() {
        return Array.from(this.notifications_.values());
    }
    get unseenNotifications() {
        return this.notifications.filter((notif) => { return !notif.seen; });
    }
    get isActive() {
        return this.socketChannel_.isOpen;
    }
    getNotification(iId) {
        return this.notifications_.find(n => n.id === iId);
    }
    deleteNotification(iId) {
        this.notifications_ = this.notifications_.filter(n => n.id !== iId);
    }
    removeNotification(iNotification) {
        let notification;
        if (typeof iNotification == 'string') {
            notification = this.getNotification(iNotification);
        }
        else {
            notification = iNotification;
        }
        if (notification) {
            this.deleteNotification(notification.id);
            if (this, this.notifyParent_)
                this.notifyParent_([]);
            return true;
        }
        return false;
    }
    updateNotification(iNotification) {
        this.removeNotification(iNotification);
        this.notifications_.push(iNotification);
        this.notifyParent_([]);
        return true;
    }
    handleMessage(event) {
        if (event.data) {
            try {
                let dataArr = JSON.parse(event.data, reviveDate);
                let actions = [];
                let notifications = [];
                dataArr.forEach(element => {
                    if ('id' in element && 'priority' in element) {
                        notifications.push(element);
                    }
                    if ('command' in element) {
                        actions.push(element);
                    }
                });
                if (actions.length > 0) {
                    actions.forEach(act => {
                        if (act.command == 'remove') {
                            this.removeNotification(act.id);
                        }
                        else if (act.command == 'update') {
                            this.updateNotification(act);
                        }
                        else {
                            console.log('unhandled action!', act.command, act);
                        }
                    });
                }
                if (notifications.length > 0) {
                    this.addNotifications(notifications);
                }
            }
            catch (error) {
                //do what?
                console.log(error);
            }
        }
        function reviveDate(iKey, iVal) {
            if (iKey == 'timestamp') {
                return new Date(iVal);
            }
            return iVal;
        }
    }
    addNotifications(iNotificationArr) {
        this.notifications_ = [...this.notifications_, ...iNotificationArr];
        this.notifyParent_(iNotificationArr);
    }
    //API
    async fetchNotifications(url) {
        var _a, _b;
        const resp = await fetchRestApi(null, { httpMethod: 'GET', picsystem: PIC.systemId, path: url });
        let resAsStr;
        if ((_b = (_a = resp.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('iso-8859-1')) {
            const data = await resp.arrayBuffer();
            const decoder = new TextDecoder('iso-8859-1');
            resAsStr = decoder.decode(data);
        }
        else
            resAsStr = await resp.text();
        try {
            const data = JSON.parse(resAsStr, (key, value) => key === 'timestamp' ? new Date(value) : value);
            if (typeof data === 'undefined' || !Array.isArray(data))
                return;
            //Hard overwrite since every time is all data
            this.notifications_ = data;
            if (this.notifyParent_)
                this.notifyParent_(null);
        }
        catch (e) {
            console.error('Error parsing notification data', e);
        }
    }
}
//# sourceMappingURL=PICNotificationManager.js.map